function lightBoxPrev(containerId) {
    var images = document.getElementById(containerId);

    
    if (images) {
        var current = images.querySelector('.current');
        current.classList.remove('current');

        if (current.previousElementSibling) {
            var nextImage = current.previousElementSibling;

            if (nextImage) {
                nextImage.classList.add('current');
            }

        } else {
            var lastImage = images.children[images.children.length - 1];

            if (lastImage) {
                lastImage.classList.add('current');
            }
        }
    }
}

function lightBoxNext(containerId) {
    var images = document.getElementById(containerId);


    if (images) {
        var current = images.querySelector('.current');
        current.classList.remove('current');

        if (current.nextElementSibling) {
            var nextImage = current.nextElementSibling;

            if (nextImage) {
                nextImage.classList.add('current');
            }

        } else {

            var firstImage = images.children[0];

            if (firstImage) {
                firstImage.classList.add('current');
            }
        }
    }
}

function toggleLightbox(id, indexTarget) {
    var container = document.getElementById(id);

    if (container) {
        if (container.classList.contains('hide')) {
            container.classList.remove('hide');
        } else {
            container.classList.add('hide');
        }
    }

    if (indexTarget) {
        var images = document.getElementById('product-images');

        if (images) {
            var current = images.querySelector('.current');
            current.classList.remove('current');

            var target = images.children[indexTarget-1];

            if (target) {
                target.classList.add('current');
            }

        }
    }
}

window.lightBoxPrev = lightBoxPrev;
window.lightBoxNext = lightBoxNext;
window.toggleLightbox = toggleLightbox;